import { FaCaretDown, FaCaretRight } from 'react-icons/fa';
import React from 'react';

function defaultHeaderRenderer({ isOpen, headerText }) {
    return (
        <h5>
            {isOpen ? <FaCaretDown /> : <FaCaretRight />} {headerText}
        </h5>
    );
}

export default defaultHeaderRenderer;
